import { FC, ReactNode } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "react-bootstrap";

import "../../styles/scss/ModalComponents/ModalTopLevel.scss";

// Define Interface
type Props = {
  id?: string;
  show?: boolean;
  onHide: () => void;
  children: ReactNode;
}

const ModalTopLevel: FC<Props> = ({
  id,
  children,
  onHide,
  show
}) => {
  return (
    <Modal
      id={`top-level-modal`}
      fullscreen={true}
      onHide={onHide}
      centered
      show={show}
      animation={false}
    >
      <div className="backdrop" />

      {children}
    </Modal>
  )
}
ModalTopLevel.defaultProps = {
  id: "",
  children: <div />,
  show: false,
  onHide: () => { }
}

export default ModalTopLevel;